import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { productShape, resolutionPropType } from "app/utils/propTypes";
import LookAlikeProduct from "app/pages/.shared/LookAlikeProduct/LookAlikeProduct";
import "./LookAlikeProducts.scss";
import useOnScreen from "app/pages/.shared/useOnScreen";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const LookAlikeProducts = ({ products = [], resolution }) => {
	const { track } = useAnalytics();
	const ref = useRef();

	const isElementOnScreen = useOnScreen({ ref, triggerOnce: true });

	useEffect(() => {
		if (isElementOnScreen && products.length > 0) {
			track("lookalike_Product_view", {
				products,
			});
		}
	}, [isElementOnScreen, products]);

	return products.length > 0 ? (
		<div className="lookalike-products" ref={ref}>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				variantMD={TYPOGRAPHY_VARIANTS.XL3}
				isBold
				className="lookalike-products__title"
				component="h2"
			>
				<FormattedMessage id="lookalike.products.title" />
			</Typography>
			<div className="lookalike-products__list">
				{products.map((product, index) => {
					return (
						<div key={product.id} className="lookalike-products__item">
							<LookAlikeProduct
								product={product}
								resolution={resolution}
								position={index}
							/>
						</div>
					);
				})}
			</div>
		</div>
	) : (
		false
	);
};

LookAlikeProducts.propTypes = {
	products: PropTypes.arrayOf(productShape),
	resolution: resolutionPropType,
};

export default LookAlikeProducts;
